(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["community-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('community-marquee')) {
    customElements.define(
      'community-marquee',
      class extends HTMLElement {
        static SPEED = 40; // px per second, matches the reference

        connectedCallback() {
          this.row = this.querySelector('.community-carousel__marquee-row');
          if (!this.row) return;
          this.resizeObserver = new ResizeObserver(() => this.setDuration());
          this.resizeObserver.observe(this.row);
        }

        disconnectedCallback() {
          this.resizeObserver?.disconnect();
        }

        setDuration() {
          const loopWidth = this.row.scrollWidth / 2;
          if (loopWidth) this.row.style.setProperty('--marquee-duration', `${loopWidth / this.constructor.SPEED}s`);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["curated-product-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('curated-product-carousel')) {
    customElements.define(
      'curated-product-carousel',
      class extends HTMLElement {
        connectedCallback() {
          const track = this.querySelector('[data-track]');
          if (!track) return;

          this.querySelectorAll('[data-direction]').forEach((button) => {
            button.addEventListener('click', () => {
              const direction = Number(button.dataset.direction);
              track.scrollBy({ left: direction * track.clientWidth * 0.75 });
            });
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-byop"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-spotlight"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('reviews-spotlight')) {
    customElements.define(
      'reviews-spotlight',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-track]');
          this.cards = [...this.querySelectorAll('[data-card]')];
          this.dots = [...this.querySelectorAll('[data-dot]')];
          if (!this.track || !this.cards.length) return;
          this.active = 0;

          this.track.addEventListener('scroll', () => this.sync(), { passive: true });
          this.dots.forEach((dot) => dot.addEventListener('click', () => this.goTo(Number(dot.dataset.dot))));
          this.querySelectorAll('[data-step]').forEach((button) =>
            button.addEventListener('click', () => this.goTo(this.active + Number(button.dataset.step)))
          );
        }

        step() {
          return this.cards[0].getBoundingClientRect().width + 12;
        }

        goTo(index) {
          const clamped = Math.max(0, Math.min(this.cards.length - 1, index));
          this.track.scrollTo({ left: clamped * this.step() });
        }

        sync() {
          const index = Math.min(this.cards.length - 1, Math.round(this.track.scrollLeft / this.step()));
          if (index === this.active) return;
          this.active = index;
          this.cards.forEach((card, i) => card.toggleAttribute('data-active', i === index));
          this.dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === index)));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
